import { ofType } from "redux-observable";

import { map, mergeMap, flatMap } from "rxjs/operators";

import { from } from "rxjs";

import { TransformResponse } from "./transform";

import {
  SETSELECTED,
  SETPATIENTSELECTED,
  NO_CHANGE,
  SET,
  RESET,
} from "one-state-subject/src/types";

import { SET as identifierAction } from "one-state-patientidentifiers/src/types";

import { setAction, reinitAction } from "one-state-pcp/src/actions";

import {
  addAction,
  reinitAction as resetError,
} from "one-state-error/src/actions";

import { ErrorObject } from "one-state-error/src/errorobject";

import { setAction as setSkeletonAction } from "one-state-skeleton";

import { Skeleton, Disposition } from "one-model-local";

import { format } from "one-util-date";

export const enum Types {
  SETPCP = "set-pcp-data/set",

  STORE_DISPOSITION_CODE = "store-disposition-code",
}

import { InvokeFinesseProxy } from "../../subject/src/index";

const pushToSkeleton = (payload: any) => setSkeletonAction(payload);

const pushToPCP = (payload: any) => ({ type: Types.SETPCP, payload });

const pushToDisposition = (payload: any) => ({
  type: Types.STORE_DISPOSITION_CODE,
  payload,
});

/** 

 * This Fuction will fetch the data of PCP 

 * from backend api and returns the response and calls 

 * subsequent redux action 

 * @param context contains the settings etc.. 

 */

export const fetchPCPEpic = (context: any) => (action$: any, state$: any) => {
  const errorTime = format(new Date(), "LT");

  const errorDate = format(new Date(), "LL");

  const {
    server,
    log,
    agentId,
    teamName,
    alertnotification,
    settings: {
      servers,

      epicendpoints: { getpcp, apitoken },

      compatible: {
        consolidated_api_invocation,
        contact_center_type,
        finesse_proxy_service,
        send_epic_client_id,
      },
    },
  } = context;

  const { locations = [] } = servers;

  return action$.pipe(
    consolidated_api_invocation ? ofType(NO_CHANGE) : ofType(identifierAction),

    // ofType(Types.PatientSet),

   

    mergeMap((action: any) => {
      /** 

                 * @param dataresponse contains the patient response 

                 */

      let pcppayload: any = action.payload;

      let patient_id = sessionStorage.getItem("subjectid");


      const postPCPRequest = (datares: any) => {
        if (datares?.[0]?.id) {
          let headers = new Headers();

          headers.set("Authorization", "Basic " + apitoken?.token);
          const epicClientId = send_epic_client_id ? (state$?.value?.epicuserid?.agentuserid || "1") : "";
          if (send_epic_client_id) {
              headers.set("Epic-Client-ID", epicClientId);
          }

          const patientid = {
            PatientID: patient_id ? patient_id : "",

            MyChartAccountID: datares[0]?.headertypeid,
          };

          let response;

          if (finesse_proxy_service) {
            response = InvokeFinesseProxy(
              getpcp,
              patientid,
              apitoken,
              locations,
              log,
              "POST",
              alertnotification,
              { "Epic-Client-ID": epicClientId }
            );
          } else {
            response = server
              .post({
                headers: headers,

                path: getpcp,

                data: patientid,
              })

              .then((responsefound: any) => responsefound)

              .catch((errorpcp: any) => {
                log.error(
                  "ccw-gadget,pcp-epic",

                  "pcp-epic",
                  {
                    errorpcp,
                  }
                );

                let errorbuild: ErrorObject = {
                  source: "PCP",

                  type: "error",

                  status: errorpcp?.status,

                  erroritems: errorpcp?.errors,

                  error_date: errorDate,

                  error_time: errorTime,
                };

                return errorbuild;
              });

            log.debug(
              "ccw-gadget,pcp-epic",

              "pcp-epic response",
              {
                response,
              }
            );
          }

          return from(response);
        } else {
          return from([]);
        }
      };

      //Calling getRequst function here

      //the reason is we need to use pipe function.

      return postPCPRequest(pcppayload)
        .pipe(map((response: any) => TransformResponse(response, context)))
        .pipe(
          flatMap((pcpresponse) => {
            const actions: any = [setAction(pcpresponse.pcp)];

            if (pcpresponse.error) {
              actions.push(addAction(pcpresponse.error));

              let disp: Disposition = { value: "1002" };

              if (contact_center_type && contact_center_type === "five9") {
                let agentIdValue = sessionStorage.getItem("agentName");

                let skillName = sessionStorage.getItem("skillName");

                disp.meta00 = agentIdValue;

                disp.meta01 = skillName;

                disp.dial_list_uid =
                  state$.value.five9Interaction?.interactionId;
              }
              else if(contact_center_type==="genesys"){
                disp.meta00 = sessionStorage.getItem("name");
                disp.meta01 = sessionStorage.getItem("agentName");
              }
              else if(contact_center_type==="twilio"){
                disp.meta00 = sessionStorage.getItem("twilio_userid");
                disp.meta01 = "";
              }
              else if(contact_center_type==="ringcentral"){
                disp.meta00 = sessionStorage.getItem("ringcentral_agentName");
                disp.meta01 = "";
              }
              else if(contact_center_type==="inContact"){
                disp.meta00 = sessionStorage.getItem("agentName");
                disp.meta01 = sessionStorage.getItem("Incontact_SkillName");
              }
              else if(contact_center_type==="vonage"){
                disp.meta00 = sessionStorage.getItem("vonage_userid");
                disp.meta01 = "";
              }
              else if(contact_center_type==="wxcc"){
                disp.meta00 = sessionStorage.getItem("wxcc_agentId");
                disp.meta01 = "";
              } 
              else if(contact_center_type==="intermedia"){
                disp.meta00 = sessionStorage.getItem("agentName");
                disp.meta01 = sessionStorage.getItem("intermedia_SkillName");
              }  
               else {
                disp.meta00 = agentId;

                disp.meta01 = teamName;

                disp.dial_list_uid = state$.value.choosecaller?.callId;
              }

              disp.meta02 = pcppayload?.id;

              disp.meta03 = pcpresponse?.error?.status;

              disp.meta04 = pcpresponse?.error?.erroritems[0]?.error_detail;
              disp.meta05 = "Failed to fetch the PCP information"

              actions.push(pushToDisposition(disp));
            } else {
              let disp: Disposition = { value: "185" };

              if (contact_center_type && contact_center_type === "five9") {
                let agentIdValue = sessionStorage.getItem("agentName");

                let skillName = sessionStorage.getItem("skillName");

                disp.meta00 = agentIdValue;

                disp.meta01 = skillName;

                disp.dial_list_uid =
                  state$.value.five9Interaction?.interactionId;
              } 
              else if(contact_center_type==="genesys"){
                disp.meta00 = sessionStorage.getItem("name");
                disp.meta01 = sessionStorage.getItem("agentName");
              }
              else if(contact_center_type==="twilio"){
                disp.meta00 = sessionStorage.getItem("twilio_userid");
                disp.meta01 = "";
              }
              else if(contact_center_type==="ringcentral"){
                disp.meta00 = sessionStorage.getItem("ringcentral_agentName");
                disp.meta01 = "";
              }
              else if(contact_center_type==="inContact"){
                disp.meta00 = sessionStorage.getItem("agentName");
                disp.meta01 = sessionStorage.getItem("Incontact_SkillName");
              }
              else if(contact_center_type==="vonage"){
                disp.meta00 = sessionStorage.getItem("vonage_userid");
                disp.meta01 = "";
              }
              else if(contact_center_type==="wxcc"){
                disp.meta00 = sessionStorage.getItem("wxcc_agentId");
                disp.meta01 = "";
              } 
              else if(contact_center_type==="intermedia"){
                disp.meta00 = sessionStorage.getItem("agentName");
                disp.meta01 = sessionStorage.getItem("intermedia_SkillName");
              }  
              else {
                disp.meta00 = agentId;

                disp.meta01 = teamName;

                disp.dial_list_uid = state$.value.choosecaller?.callId;
              }

              disp.meta02 = pcpresponse?.id;
              disp.meta03 = "PCP information fetched successfully"

              actions.push(pushToDisposition(disp));
            }

            let skeletonPatientCare: Skeleton = {
              pendingCare_skeleton: false,
            };

            actions.push(pushToSkeleton(skeletonPatientCare));

            return actions;
          })
        );
    })
  );
};

export const clearPCPEpic = (context: any) => (action$: any) => {
  const { log } = context;

  log.debug(
    "ccw-gadget, pcp-epic",

    "clear-PCP-epic",
    {}
  );

  return action$.pipe(
    ofType(SET, SETSELECTED, RESET, SETPATIENTSELECTED),

    map((action) => reinitAction())
  );
};

export const clearErrorEpic = (context: any) => (action$: any) => {
  const { log } = context;

  log.debug(
    "ccw-gadget, pcp-epic",
    "clear-Error-epic",
    {}
  );

  return action$.pipe(
    ofType(RESET),
    map((action) => resetError())
  );
};
